import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=24eb3f04"
import script from "./Request.vue?vue&type=script&lang=js"
export * from "./Request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24eb3f04')) {
      api.createRecord('24eb3f04', component.options)
    } else {
      api.reload('24eb3f04', component.options)
    }
    module.hot.accept("./Request.vue?vue&type=template&id=24eb3f04", function () {
      api.rerender('24eb3f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/Request.vue"
export default component.exports